/**
 * Popup Modal component
 * 
 * @module popup-modal
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'popup-modal';

if (!customElements.get(customElements.component)) {
  
    class quantitySelector extends HTMLElement {

        /**
         * Web component constructor
         * 
         * @constructor
         */
        constructor() {

            super();
            
            this.style.display = 'none';
            
            this.classList.add('popup-modal');

            this.render();
        }

        /**
         * Render component in the DOM
         * 
         * @returns {undefined}
         */
        render() {

            // Render template

            let html = this.template();

            html = html.replace(/{{content}}/g, this.innerHTML);

            this.innerHTML = html;

            // After render template

            this.initEvents();

            this.style.display = '';

            let displayClose = (typeof this.dataset.displayClose != 'undefined') ? true : false;
            if(displayClose){
                let closeBtn = this.querySelector('[data-close]');
                if(closeBtn){
                    closeBtn.classList.remove('hidden');
                }
            }
            
        }

        /**
         * Component template
         * 
         * @returns {undefined}
         */
         template() {

            if (window.templatePopUpModal) {

                return window.templatePopUpModal;

            } else {

                return `
                    <div data-overlay></div>
                    <div data-container>
                        <button data-close>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M6 18L18 6M6 6L18 18" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            Close
                        </button>
                        <div data-content>{{content}}</div>
                    </div>
                `;
            }
        }

        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            this.initFocusTrap();

            this.initTriggers();

            // Close on press escape
            window.addEventListener('escape', () => {
                this.close();
            });
        }

        /**
         * Init triggers
         * 
         * @returns {undefined}
         */
        initTriggers() {

            if(this.id) {

                document.querySelectorAll('[data-modal-target="'+this.id+'"]').forEach( element => {
                    element.addEventListener('click', this.open.bind(this) );
                });

            }

            this.querySelector('[data-overlay]').addEventListener('click', this.close.bind(this) );

            this.querySelector('[data-close]').addEventListener('click', this.close.bind(this) );
        }

        /**
         * Check if the drawer is open
         * 
         * @returns {boolean}
         */
        isOpen() {

            return (this.classList.contains('active')) ? true : false;
        }

        /**
         * Open drawer
         * 
         * @returns {undefined}
         */
        open() {

            if (!this.isOpen()) {

                this.classList.add('active');
                this.classList.add('transition-in');

                setTimeout(() => {
                    this.classList.remove('transition-in');
                    this.activeFocusTrap();
                }, 300);
            }
        }

        /**
         * Close drawer
         * 
         * @returns {undefined}
         */
        close() {

            if (this.isOpen()) {

                this.classList.add('transition-out');
                this.disableFocusTrap();

                setTimeout(() => {
                    this.classList.remove('transition-out');
                    this.classList.remove('active');
                }, 300);
            }
        }

        /**
         * Init focus trap
         * 
         * @returns {undefined}
         */
        initFocusTrap() {

            this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true }); 
        }

        /**
         * Disable focus trap
         * 
         * @returns {undefined}
         */
        disableFocusTrap() {

            if (this.focusTrap) {
                this.focusTrap.deactivate();
            }
        }

        /**
         * Active focus trap
         * 
         * @returns {undefined}
         */
        activeFocusTrap() {

            if (this.focusTrap) {
                this.focusTrap.activate();
            }
        }
    }

    customElements.define(customElements.component, quantitySelector);
}
